import { colors } from "assets";
import React, { useState } from "react";
import styles from './button.module.scss'
import { BsArrowRight } from "react-icons/bs";
import { Box, } from "@mui/material";


const ERCButton = ({ children, type = 'button', className, h, loading = false, size = '12px', weight, g, border, disabled, height = '56px', p, showArrow, bgcolor = colors.ercButtonPrimary, color = 'white', width = '160px',  outlineColor = 'transparent', onClick }) => {

    const [hover, setHover] = useState(false)

    return (
        <Box className={`${styles.btn} ${className}  `}
            component={'button'}
            onClick={onClick}
            sx={{
                border: hover ? 'none' : border,
                fontSize: size,
                fontFamily: 'Manrope',
                bgcolor,
                textTransform: 'capitalize',
                height,
                color,
                // disabled,
                 outline: `2px solid ${outlineColor}`,
                width,
                gap: g,
                padding: p,
                borderRadius: width === '101px' ? '4px' : '8px',
                boxShadow: bgcolor === colors.ercButtonFaint ? '0px 4px 4px 0px rgba(11, 112, 119, 0.37)' : 'none',
                "&:hover": {
                    color: "#ffffff",
                    bgcolor: colors.ercButtonHover,
                    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                },

            }}
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            disabled={disabled}
            // onClick={onClick}
            type={type}
        >
            <p style={{ fontWeight: weight }} >{loading ? 'Loading' : children}</p>
            {showArrow && <BsArrowRight />}
            {/* <button hidden type='submit'></button> */}
        </Box>
    )
}

export {
    ERCButton
}

